import { observer, Observer } from 'mobx-react-lite';
import React from 'react';
import { MultiGrid } from 'react-virtualized';

const ObservableMultiGrid = observer((props: any) => {
    const cellRenderer = (cellProps: any) => (
        <Observer key={cellProps.key}>{() => props.cellRenderer(cellProps)}</Observer>
    );

    return <MultiGrid {...props} cellRenderer={cellRenderer} />;
});

export default ObservableMultiGrid;
